import { render, staticRenderFns } from "./StreetCompassWrapper.vue?vue&type=template&id=4650e348&scoped=true&"
import script from "./StreetCompassWrapper.vue?vue&type=script&lang=js&"
export * from "./StreetCompassWrapper.vue?vue&type=script&lang=js&"
import style0 from "./StreetCompassWrapper.vue?vue&type=style&index=0&id=4650e348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4650e348",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4650e348')) {
      api.createRecord('4650e348', component.options)
    } else {
      api.reload('4650e348', component.options)
    }
    module.hot.accept("./StreetCompassWrapper.vue?vue&type=template&id=4650e348&scoped=true&", function () {
      api.rerender('4650e348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/StreetCompassWrapper.vue"
export default component.exports